import toggleMenu from "./toggleMenu";

//Use helper function `toggleMenu` to allow navbar to be dynamic when changing width of the screen
const persistToggleMenu = () => {
    let currentPage = window.location.href.split('/')
    currentPage = currentPage[currentPage.length - 1].trim()
    //'' is home
    window.scrollTo(0,0)
    if (currentPage === '')
        currentPage = 'home'
    const options = ['home','team', 'news', 'training', 'contact']
    options.forEach(option => {
        if (currentPage === option) {
            toggleMenu(currentPage)
        }
    })
}
export default  persistToggleMenu;

